<template>
	<brows-layout @edit="$emit('edit')" @next="$emit('next')" edit-button-top>
		<el-row type="flex" :gutter="20">
			<el-col class="col" gutter="10">
				<div class="thumb center bg-black-gray2 color-text2" :style="thumbUrl(data.feeling)">
					<span v-if="!thumbUrl(data.feeling)">感受</span>
				</div>
				<p>{{thumbDescription(data.feeling)}}</p>
				<div class="name color-danger" v-if="!data.feeling || (data.feeling && data.feeling.length < 1)">尚未上傳</div>
			</el-col>
			<el-col class="col" gutter="10">
				<div class="thumb center bg-black-gray2 color-text2" :style="thumbUrl(data.imagine)">
					<span v-if="!thumbUrl(data.imagine)">想像</span>
				</div>
				<p>{{thumbDescription(data.imagine)}}</p>
				<div class="name color-danger" v-if="!data.imagine || (data.imagine && data.imagine.length < 1)">尚未上傳</div>
			</el-col>
			<el-col class="col" gutter="10">
				<div class="thumb center bg-black-gray2 color-text2" :style="thumbUrl(data.implement)">
					<span v-if="!thumbUrl(data.implement)">實踐</span>
				</div>
				<p>{{thumbDescription(data.implement)}}</p>
				<div class="name color-danger" v-if="!data.implement || (data.implement && data.implement.length < 1)">尚未上傳</div>
			</el-col>
			<el-col class="col" gutter="10">
				<div class="thumb center bg-black-gray2 color-text2" :style="thumbUrl(data.share)">
					<span v-if="!thumbUrl(data.share)">分享</span>
				</div>
				<p>{{thumbDescription(data.share)}}</p>
				<div class="name color-danger" v-if="!data.share || (data.share && data.share.length < 1)">尚未上傳</div>
			</el-col>
		</el-row>
	</brows-layout>
</template>

<script>
import BrowsLayout from "./BrowsLayout.vue";
import { mapState } from "vuex";
export default {
	components: { BrowsLayout },
	data() {
		return {};
	},
	computed: {
		...mapState("story", ["editStoryData"]),
		data() {
			return this.editStoryData.pictures || {};
		}
	},
	methods: {
		thumbUrl(arr = []) {
			const item = arr.find(item => item.is_cover);
			const url = item ? item.url : "";
			return url ? `background-image:url(${url})` : "";
		},
		thumbDescription(arr = []) {
			const item = arr.find(item => item.is_cover);
			const description = item ? item.description : "";
			return description ? description : "圖片說明";
		}
	}
};
</script>

<style lang="scss" scoped>
.thumb {
	width: 100%;
	height: 100px;
	background-color: #ececec;
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
}
</style>
